module.exports = __webpack_public_path__ + "img/mockup-chart-weekly.63c88aa6.png";